function on(element: HTMLElement, eventType: string, selector: any, callback: any, capture: boolean = false): void {
    // If selector is function
    if (typeof selector === 'function') {
        capture = callback;
        callback = selector;
        selector = null;
    }

    //
    capture = Boolean(capture);

    // Get elements
    const elements = selector ? element.querySelectorAll(selector) : [element];

    // Foreach Elements
    for (const item of elements) {
        item.addEventListener(eventType, callback, capture);
    }
}

function off(element: HTMLElement, eventType: string, selector: any, callback: any, capture: boolean = false): void {
    // If selector is function
    if (typeof selector === 'function') {
        capture = callback;
        callback = selector;
        selector = null;
    }

    //
    capture = Boolean(capture);

    // Get elements
    const elements = selector ? element.querySelectorAll(selector) : [element];

    // Foreach Elements
    for (const item of elements) {
        item.removeEventListener(eventType, callback, capture);
    }
}

// ----------------------------------------------------------------------------

export { off, on };
